import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutPage from "./pages/About";
import Services from "./pages/Services";
import ComingSoon from "./pages/ComingSoon";
import Products from "./pages/Products";
import GetInTouch from "./pages/GetInTouch";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="font-body text-dark bg-light">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={
            <>
              <AboutPage />
              <Footer />
            </>
          } />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/get-in-touch" element={<GetInTouch />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}